import { render, staticRenderFns } from "./ServerDialogComponent.vue?vue&type=template&id=dc33b464&"
import script from "./ServerDialogComponent.vue?vue&type=script&lang=js&"
export * from "./ServerDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports